export const URL_EXPIRATION_TIME_REFRESH = 1000 * 60 * 5 - 10000;
